import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import SelectSearch from "react-select-search";

import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddDoTaskPhoneContent = (props) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState(+props.leadData);

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const addClientContact = async (e) => {
    if (validatePayment()) {
      setLoading(true);
      var body = {
        type: props.ass4
          ? "Telefoniczny - skuteczny"
          : "Telefoniczny - nieskuteczny",
        content: content.replaceAll("'", ""),
        date: new Date(),
        leadId: props.lead,
        user: props.user.name,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addSellClientContact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logLeadAction("Dodano kontakt z klientem", props.lead);

      if (
        props.taskData.task ===
        "Skontaktuj się telefonicznie z klientem – pierwszy kontakt"
      ) {
        props.close();
      } else {
        if (props.ass) {
          props.close();
        } else {
          MySwal.fire({
            title: "Czy chcesz dodać termin kolejnego kontaktu?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then((result) => {
            if (result.isConfirmed) {
              props.closePlus();
            } else if (result.isDenied) {
              props.close();
            }
          });
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (content.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id="popUpLoading" />
      ) : (
        <>
          <div id="addPaymentIC" className="inputContainer">
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Wprowadź notatkę z rozmowy</label>
                <textarea
                  spellCheck="false"
                  className="textAreaNote"
                  type="text"
                  id="url"
                  name="url"
                  value={content}
                  onChange={handleContentChange}
                />
              </div>
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={addClientContact}>
                zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddDoTaskPhoneContent;
